import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AdminAddTruckTypeComponent } from "../admin-add-truck-type/admin-add-truck-type.component";
import { AdminService } from "../admin.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CommonHelperComponent } from "src/app/common-helper/common-helper.component";

@Component({
  selector: "app-admin-truck-type",
  templateUrl: "./admin-truck-type.component.html",
  styleUrls: ["./admin-truck-type.component.css"],
})
export class AdminTruckTypeComponent implements OnInit {
  matdialogref!: MatDialogRef<AdminAddTruckTypeComponent>;
  tripType: any = "-1";
  SelectedItems: number = 0;
  DeleteAction: boolean = false;
  deleteAction: boolean = false;
  selectAction: boolean = true;
  truckTypeList: any;
  typeDeleteId: any = [];
  token: any;
  document_array: any = [];
  fetch_page: any = 0;
  currentPage: any = 0;
  total_cat_count: any;
  startPage: any = 1;
  perPage: any = 10;
  page: any = 1;
  last_page: any = 1;
  searchButton: boolean = true;
  toggleSearch: boolean = false;
  truckTypeNumber: any = -1;
  loading: boolean = false;
  addBtn: boolean = true;
  cancelAction: boolean = false;
  search_btn: boolean = false;
  clear_Btn: boolean = false;
  isInputValid: boolean = false;
  previousValue: string = "";

  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;
  @ViewChild("newItem") newItem: ElementRef;

  constructor(
    private matDialog: MatDialog,
    private service: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.GetTruckType(this.truckTypeNumber);
    // this.pagination(1);
    const savedPage = sessionStorage.getItem("lastTruckTypeFetchPage");
    this.fetch_page = savedPage ? parseInt(savedPage) : 1;

    this.startPage = this.fetch_page;
    this.currentPage = this.fetch_page;

    this.tripType = "truck-category";
    localStorage.setItem("tripType", this.tripType);
  }

  public GetTruckType(type: any) {
    this.loading = true;
    this.truckTypeNumber = type;
    this.service
      .GetTruckType(
        this.token,
        this.truckTypeNumber,
        this.perPage,
        this.startPage
      )
      .subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === 200) {
            this.truckTypeList = response.body.data;
            this.document_array.push(response.body.meta);
            this.last_page = response.body.meta.lastPage;
          }
        },
        (error) => {
          this.loading = false;
          this.truckTypeList = [];
          if ((error.status = 404)) {
            return;
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public action(event: any, data: any) {
    this.matdialogref = this.matDialog.open(AdminAddTruckTypeComponent, {
      width: "40vw",
      height: "65vh",
      data: event === "Edit" ? data : null,
      autoFocus: false,
    });
    this.matdialogref.afterClosed().subscribe((dia: any) => {
      this.GetTruckType(this.truckTypeNumber);
    });
  }

  public Selected() {
    this.DeleteAction = true;
    this.deleteAction = true;
    this.selectAction = false;
    this.toggleSearch = false;
    this.searchButton = true;
    this.cancelAction = true;
    this.addBtn = false;
    this.searchButton = false;
  }

  public matItem(event: any, item: any, index: number) {
    if (event.checked) {
      this.typeDeleteId.push(item);
      this.SelectedItems += 1;
    } else {
      this.typeDeleteId.splice(index, 1);
      this.SelectedItems -= 1;
    }
  }

  public onCancel() {
    this.selectAction = true;
    this.DeleteAction = false;
    this.deleteAction = false;
    this.SelectedItems = 0;
    this.typeDeleteId = [];
    this.toggleSearch = false;
    this.searchButton = true;
    this.cancelAction = false;
    this.addBtn = true;
    this.truckTypeNumber = -1;
    this.GetTruckType(this.truckTypeNumber);
  }

  public onDeleteType() {
    if (this.SelectedItems <= 0) {
      this.snackBar.open("Please select trucks to delete", "Fail", {
        duration: 5000,
      });
      return;
    } else {
      const dialogRef = this.matDialog.open(CommonHelperComponent, {
        data: {
          message: 'Are you sure you want to delete this record?'
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === 'yes') {
          this.service
            .DeleteTruckType({ ids: this.typeDeleteId }, this.token)
            .subscribe(
              (response: any) => {
                if (response.status === 200 || response.status === 201) {
                  this.onCancel();
                  this.snackBar.open("Truck type deleted successfully", "Success", {
                    duration: 5000,
                  });
                  this.GetTruckType(this.truckTypeNumber);
                }
              },
              (error) => {
                if (error.error.message === "jwt malformed") {
                  this.router.navigateByUrl("admin/login");
                  window.localStorage.clear();
                }
                if (error.error.message === "jwt expired") {
                  this.router.navigateByUrl("admin/login");
                  window.localStorage.clear();
                }
                if (error.error.message === "invalid signature") {
                  this.router.navigateByUrl("admin/login");
                  window.localStorage.clear();
                }
                this.snackBar.open(error.error.message, "Fail", {
                  duration: 5000,
                });
              }
            );
        }
      });
    }
  }

  // pagination(page_status: any) {
  //   if (page_status == "-1") {
  //     this.fetch_page = parseInt(this.fetch_page) - 1;
  //     this.currentPage = this.fetch_page;
  //     this.startPage = this.currentPage;
  //   }
  //   if (page_status == "1") {
  //     this.currentPage = parseInt(this.fetch_page) + 1;
  //     this.fetch_page = this.currentPage;
  //     this.startPage = this.fetch_page;
  //   }
  //   if (page_status == "first") {
  //     this.fetch_page = this.document_array[0].currentPage;
  //     this.startPage = this.document_array[0].currentPage;
  //   }
  //   if (page_status == "last") {
  //     this.fetch_page = this.document_array[0].lastPage;
  //     this.startPage = this.document_array[0].lastPage;
  //   }
  //   this.GetTruckType(this.truckTypeNumber);
  // }

  pagination(page_status: any) {
    let newPage = this.fetch_page;

    if (page_status == "-1") {
      newPage = Math.max(1, this.fetch_page - 1); // Prevent negative pages
    } else if (page_status == "1") {
      newPage = this.fetch_page + 1;
    } else if (page_status == "first") {
      newPage = 1; // Set the first page correctly
    } else if (page_status == "last") {
      newPage = this.last_page || 1; // Ensure last page is fetched correctly
    }

    this.fetch_page = newPage;
    this.currentPage = newPage;
    this.startPage = newPage;

    // Save current page to localStorage
    sessionStorage.setItem("lastTruckTypeFetchPage", newPage.toString());

    this.GetTruckType(this.truckTypeNumber);
  }
  openSearch() {
    this.search_btn = true;
    this.clear_Btn = false;
    this.toggleSearch = true;
    this.searchButton = false;
    this.addBtn = false;
    this.cancelAction = true;
    this.deleteAction = true;
    this.DeleteAction = true;
    this.selectAction = false;
    if (this.toggleSearch) {
      setTimeout(() => this.inputElement.nativeElement.focus(), 0);
    }
  }
  search(value: any) {
    const words = value.toLowerCase().split(" ");
    const capitalizedValue = words
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
    if (value != "") {
      this.searchButton = false;
      this.search_btn = false;
      this.clear_Btn = true;
      this.startPage = 1;
      this.GetTruckType(capitalizedValue);
    } else {
      this.resetSearch();
    }
  }

  resetSearch() {
    this.newItem.nativeElement.value = "";
    this.search_btn = true;
    this.clear_Btn = false;
    this.searchButton = true;
    this.truckTypeNumber = -1;
    this.GetTruckType(this.truckTypeNumber);
    this.fetch_page = 0;
    this.pagination(1);
    this.searchButton = true;
    this.toggleSearch = false;
    this.addBtn = true;
    this.selectAction = true;
    this.cancelAction = false;
    this.deleteAction = false;
    this.DeleteAction = false;
  }

  onInputChange(value: any) {
    const containsSpecialChars = /[^\w\d\s]/.test(value);
    if (containsSpecialChars) {
      value = value.replace(/[^\w\d\s]/g, "");
      this.snackBar.open(
        "Special characters are not allowed, except spaces",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }

    const words = value.toLowerCase().split(" ");
    const capitalizedValue = words
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    const previousLength = this.previousValue.length;
    this.previousValue = capitalizedValue;

    if (
      capitalizedValue.length < previousLength ||
      (capitalizedValue.length > previousLength && this.clear_Btn)
    ) {
      this.truckTypeNumber = -1;
      this.GetTruckType(this.truckTypeNumber);
      this.fetch_page = 0;
      this.pagination(1);
      this.search_btn = true;
      this.clear_Btn = false;
    }

    if (capitalizedValue.length >= 1) {
      this.isInputValid = true;
    } else {
      this.resetSearch();
    }
  }
}
